import useTranslator from "../../hooks/useTranslator";
import { canonicalizeMissingDocKey } from "../../Utils/missingDocNote";
import { ViewNoteIcon } from "./ViewMissingDocNoteButton";

// Landlord report view of the tenant's explanation note: read-only.
// Explained missing rows show a "View note" pill scrolling to the note box
// at the end of Documentos; the box's document links scroll back to these
// rows. Element ids pair both directions via the canonical document key so
// every vocabulary (sign-up, profile, forensic) lands on the same row.
export const LANDLORD_MISSING_DOC_NOTE_BOX_ID = "landlord-missing-doc-note";
export const getMissingDocRowAnchorId = (docKey) => {
  const canonical =
    canonicalizeMissingDocKey(docKey) || String(docKey ?? "").toLowerCase();
  const slug = canonical.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return `missing-doc-row-${slug || "doc"}`;
};

const LandlordNotePillButton = ({ onScrollToNote }) => {
  const { _t } = useTranslator();
  if (typeof onScrollToNote !== "function") return null;
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onScrollToNote();
      }}
      className="d-flex align-items-center custom-gap-2 cursor-pointer"
      style={{
        background: "#fffbec",
        border: "1px solid #FACD7D",
        borderRadius: 999,
        padding: "2px 10px",
        fontSize: 12,
        lineHeight: "16px",
      }}
    >
      <ViewNoteIcon />
      {_t("viewNote", "View note")}
    </button>
  );
};

export default LandlordNotePillButton;
